import { YardBlockAssignmentDto } from '@operations/app/api'

export interface EquipmentFormProfile {
  id?: number
  name: string
  description?: string | null
  equipmentType: number | string
  isActive: boolean
  maxLiftWeight?: number | null
  maxStackingHeight?: number | null
  yardBlockAssignments?: YardBlockAssignmentDto[]
  isOwned: boolean
}

export const defaultValues: EquipmentFormProfile = {
  name: '',
  equipmentType: '',
  description: '',
  isActive: true,
  maxLiftWeight: undefined,
  maxStackingHeight: undefined,
  yardBlockAssignments: [],
  isOwned: true,
}
